export const LOADING_TIPS = [
  "为保证模型能成功调用，请将令牌多设置几个分组。",
  "一般来说，模型版本越高质量越好。",
  "您可以随时更改剧本和分镜，AI会根据您的修改重新生成",
  "在生成视频前，请确保分镜画面符合您的预期。",
  "遇到生成失败时，可以尝试点击重新生成按钮。"
];
